/**
 * Polar-Gates für den synthetischen OGH-/Litigation-Demo-Job (Portal_Arbeiten).
 *
 * Klasse PORTAL_JUD_DEMO_HOST
 *   VERBOTEN: Demo-Start auf Live `portal-labor.arkorbit.at` (Feature-Dist).
 *   ERLAUBT: Demo-Start auf `portal-dev-labor.arkorbit.at`.
 *
 * Klasse PORTAL_JUD_DEMO_WORKER
 *   VERBOTEN: UI tut so, als liefe eine Analyse, wenn der Worker tot/502 ist.
 *   ERLAUBT: Karte sichtbar, Start disabled, ehrlicher Fehlercode, Polling stoppt.
 */

export const JUDICATURE_DEMO_LIVE_HOST = 'portal-labor.arkorbit.at';
export const JUDICATURE_DEMO_DEV_HOST = 'portal-dev-labor.arkorbit.at';

/** Live-Portal (nur `main`-Dist). Feature-Branches dürfen hier nicht starten. */
export function isLaborLivePortalHostname(hostname: string): boolean {
  return hostname.trim().toLowerCase() === JUDICATURE_DEMO_LIVE_HOST;
}

/** Host, auf dem der synthetische Demo-Job gestartet werden darf. */
export function isJudicatureDemoJobHost(hostname: string): boolean {
  return hostname.trim().toLowerCase() === JUDICATURE_DEMO_DEV_HOST;
}

export const JUDICATURE_DEMO_WORKER_UNAVAILABLE_CODES = [
  'LITIGATION_WORKER_UNAVAILABLE',
  'LITIGATION_WORKER_RESPONSE_INVALID',
  'ORCHESTRATOR_NOT_CONFIGURED',
  'HTTP_502',
  'HTTP_503',
  'HTTP_504',
] as const;

export function isJudicatureDemoWorkerUnavailable(code: string): boolean {
  const c = code.trim();
  if (!c) return false;
  if ((JUDICATURE_DEMO_WORKER_UNAVAILABLE_CODES as readonly string[]).includes(c)) {
    return true;
  }
  if (/^HTTP_5\d\d$/.test(c)) return true;
  if (/failed to fetch/i.test(c)) return true;
  if (/networkerror/i.test(c)) return true;
  if (/the operation was aborted/i.test(c)) return true;
  if (/timeout/i.test(c) && /abort/i.test(c)) return true;
  return false;
}
